module.exports = __webpack_public_path__ + "static/img/a3.d764f47b.jpg";